export default "__VITE_ASSET__DR3$uQuN__"